import { takeLatest, put, call } from 'redux-saga/effects'
import { signup } from '../../../../utils/User/axios'
import { signupRequest, signupRequestSuccess, signupRequestFailed } from '../Reducer'
import { loginRequest } from '../../Login/Reducer'

export default function* signupWatcherSaga() {
  yield takeLatest(signupRequest.type, signupSaga)
}

function* signupSaga({ payload }) {
  try {
    const {
      contact, name, email, username, password, district, history,
    } = payload
    const response = yield call(signup, {
      contact, name, email, username, password, district,
    })
    yield put(signupRequestSuccess(response))
    yield put(loginRequest({ contact, password, history }))
  } catch (error) {
    yield put(signupRequestFailed(error))
  }
}
